<!--
 * @Author: DY
 * @Date: 2025-02-17 17:58:48
 * @LastEditTime: 2025-03-21 16:40:07
 * @Description: 客户验收审批【销售管理】
 * @FilePath: \ShiMo_Mobile\src\views\sales\customerAcceptanceApproval\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="customerAcceptanceApproval commonListStyles">
            <van-nav-bar
                left-arrow
                left-text="应用"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            >
                <template #title>
                    <div :class="{'active': listType == '1'}" @click="listSwitch('1')">
                        待审批
                    </div>
                    <div :class="{'active': listType == '2'}" @click="listSwitch('2')">
                        已审批
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">质量验收单号：{{ item.check_accept_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.approve_status_str }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>客户名称：{{ item.client_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料代码：{{ item.material_codes }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>发货数量（吨）：{{ item.delivery_weight }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>签收数量（吨）：{{ item.sign_weight }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="danger" @click="openDetails(item)">
                                            发货明细
                                        </van-button>
                                        <van-button
                                            plain
                                            type="danger"
                                            v-if="listType == 1"
                                            @click="toDetail(item, 'view')"
                                        >
                                            办理
                                        </van-button>
                                        <van-button
                                            plain
                                            type="danger"
                                            v-if="listType == 2"
                                            @click="toDetail(item, 'view')"
                                        >
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'customer-acceptance-approval',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'customer-acceptance-approval');
        }
        next();
    },
    data() {
        return {
            listType: '1',
            tableCode: 'client_check_accept_approval',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                approve_status: this.listType,
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                [this.searchKey]: this.keyVal,
            };
        },
        // 待办已办切换
        listSwitch(obj) {
            this.pageIndex = 0;
            this.listData = [];
            this.listType = obj;
            this.finished = false;
            this.initPage();
        },
        openDetails(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'customerAcceptanceApprovalForm',
                params: {
                    delivery_notice_id: item.delivery_notice_id,
                    material_codes: item.material_codes,
                },
            });
        },
        toDetail(item) {
            item.BusinessInstanceId = item.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: item,
                    isReadOnly: this.listType === '1' ? false : true,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.customerAcceptanceApproval
    width 100%
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
